'use client'
import ErrorComponent from '@/components/Error'

export default function NotFound({ error }: { error: Error }) {
    return <ErrorComponent heading="Page not found!" error={error} />
}
